import { ScrollAnimatedElement } from './scrollElement'

document.addEventListener( 'DOMContentLoaded', initProgressBar );

function initProgressBar() {

	const txtElements = document.querySelectorAll( '.wp-block-aver-progressbar-block' );

	txtElements.forEach( ( txtElement ) => {
		new ProgressBar( txtElement);
	} );
}

class ProgressBar extends ScrollAnimatedElement {
  constructor(txtElement) {
    super(txtElement);

    this.circle = txtElement.querySelector('.circular-progress.circle');
    this.bar = txtElement.querySelector('.circular-progress.bar .inner-circle');
    this.number = txtElement.querySelector('.counter');
    this.ptype = txtElement.getAttribute('data-ptype');
    this.comma = txtElement.getAttribute('data-comma');  

    this.display = this.ptype == 'circle'
      ? this.circle?.querySelector('.percentage')
      : this.ptype == 'bar' ? this.bar?.querySelector('.percentagebar') : this.number  ;

    this.progressColor = txtElement.dataset.progressColor
      ? JSON.parse(txtElement.getAttribute('data-progress-color'))
      : ['#f1f1f1', '#555', '#ccc'];
  }

  update() {
    if (this.number < this.targetnumber) {
      if (this.display) this.display.innerText = `${this.number}`;

      if (this.circle) {
        this.circle.style.background = `conic-gradient(${this.progressColor[1]} ${this.number * 3.6}deg, ${this.progressColor[2]} 0deg)`;
      }
      if (this.bar) {
        this.bar.style.width = `${this.number}%`;
      }
      if (this.number) {

      }

      this.temp = this.number;
    } else {
      if ( this.display && this.ptype == 'number' && this.comma ) {
        this.display.innerText = this.targetnumber.toLocaleString('en-US');
      } else this.display.innerText = this.targetnumber;
      clearInterval(this.timer);
      this.timer = null;
    }

    this.number += this.increment;
  }

  resetDisplay() {
    if (this.display) this.display.innerText = '';
    if (this.bar) this.bar.style.width = '0%';
    if (this.circle) this.circle.style.background = `conic-gradient(${this.progressColor[2]} 0deg, ${this.progressColor[2]} 0deg)`;
  }
}
